import getUrlPath from '../../utils/getUrlPath';
import ViewOnScreen from '../../components/view-on-screen/ViewOnScreen';
import { auth } from '../../utils/auth';
import { dispatchCloseMenuEvent } from '../../utils/menu';
import { FormattedMessage } from 'react-intl';
import { Menu } from '@app/types/menu';
import { redirectToSignUp } from '../../utils/router';
import { useAuthState } from '../../hooks/useAuthState';
import { url } from '../../constants/url';
import { useLocation } from 'react-router-dom';
import {
  AccountInfo,
  AreaOne,
  CloseButton,
  CloseIcon,
  ManageProfileIcon,
  ManageProfileIconContainer,
  ManageProfileLink,
  SignInButton,
  SignInWrapper,
  SignupContent,
  SignupText,
  StartHere,
  UserInfo,
  UserLabel,
  UserMenuAuthSkeleton,
  UserName,
  WelcomeText,
} from './Style';

function PrimaryMenuLinks() {
  const location = useLocation();

  const { authState, isAuthenticated, isAuthInitialized } = useAuthState();

  const showSkeleton = !isAuthInitialized;

  const handleSignup = () => {
    redirectToSignUp(location.pathname);
  };

  return (
    <AreaOne>
      {showSkeleton ? (
        <SignInWrapper aria-busy aria-label="Loading account">
          <UserMenuAuthSkeleton variant="rounded" animation="wave" />
        </SignInWrapper>
      ) : isAuthenticated ? (
        <AccountInfo>
          <ViewOnScreen screen={{ up: 'xs' }}>
            <UserInfo>
              <WelcomeText>
                <FormattedMessage id={'userDropdown.labels.welcome'} />
              </WelcomeText>
              <UserName>{authState.authContext?.fullName}</UserName>
            </UserInfo>
            <ManageProfileLink href={getUrlPath(url.account.subPath.profile.id)}>
              <FormattedMessage id={'userDropdown.links.manageProfile'} />
              <ManageProfileIconContainer>
                <ManageProfileIcon />
              </ManageProfileIconContainer>
            </ManageProfileLink>
          </ViewOnScreen>
          <ViewOnScreen screen={{ down: 'xs' }}>
            <UserInfo>
              <UserLabel>
                <FormattedMessage id={'userDropdown.labels.welcome'} />
              </UserLabel>
              <UserName>{authState.authContext?.fullName}</UserName>
            </UserInfo>
            <CloseButton onClick={() => dispatchCloseMenuEvent(Menu.USER_MENU)}>
              <CloseIcon></CloseIcon>
            </CloseButton>
          </ViewOnScreen>
        </AccountInfo>
      ) : (
        <SignInWrapper>
          <SignInButton onClick={() => auth.login()}>
            <FormattedMessage id={'userDropdown.labels.signIn'} />
          </SignInButton>
          <SignupContent>
            <SignupText>
              <FormattedMessage id={'userDropdown.signUp.newCustomer'} />
              <StartHere as='span' onClick={handleSignup}>
                <FormattedMessage id={'userDropdown.signUp.startHere'} />
              </StartHere>
            </SignupText>
          </SignupContent>
        </SignInWrapper>
      )}
    </AreaOne>
  );
}

export default PrimaryMenuLinks;
